function setLocalStorageItem(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
  
  function getLocalStorageItem(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  
  /********************** Functions **********************/
  
  function showNotEligible() {
    document.getElementById("quiz-no").style.display = "block";
  }
  
  function hideNotElegible() {
    document.getElementById("quiz-no").style.display = "none";
  }
  
  function showQuestionLander() {
    document.getElementById("quiz-lander").style.display = "block";
  }
  
  function hideQuestionLander() {
    document.getElementById("quiz-lander").style.display = "none";
  }
  
  function hideQuizStatus() {
    document.getElementById("quiz-status").style.display = "none";
  }
  
  function showQuizStatus(question, total) {
    document.getElementById("quiz-status").style.display = "flex";
    document.getElementById("question-number").innerHTML =
      question + "/" + total;
    document.getElementById("progress-current").style.width =
      (question / total) * 100 + "%";
  }
  
  function showQuestionZeroOne() {
    document.getElementById("quiz-question-zero-one").style.display = "block";
    showQuizStatus(1, 17);
  }
  
  function hideQuestionZeroOne() {
    document.getElementById("quiz-question-zero-one").style.display = "none";
  }
  
  function showQuestionZeroTwo() {
    document.getElementById("quiz-question-zero-two").style.display = "block";
    showQuizStatus(2, 17);
  }
  
  function hideQuestionZeroTwo() {
    document.getElementById("quiz-question-zero-two").style.display = "none";
  }
  
  function showQuestionOne() {
    document.getElementById("quiz-question-one").style.display = "block";
    showQuizStatus(3, 17);
  }
  
  function hideQuestionOne() {
    document.getElementById("quiz-question-one").style.display = "none";
  }
  
  function showQuestionTwo() {
    document.getElementById("quiz-question-two").style.display = "block";
    showQuizStatus(4, 17);
  }
  
  function hideQuestionTwo() {
    document.getElementById("quiz-question-two").style.display = "none";
  }
  
  function showQuestionThree() {
    document.getElementById("quiz-question-three").style.display = "block";
    showQuizStatus(5, 17);
  }
  
  function hideQuestionThree() {
    document.getElementById("quiz-question-three").style.display = "none";
  }
  
  function showQuestionThreeOne() {
    document.getElementById("quiz-question-three-one").style.display = "block";
    showQuizStatus(6, 17);
  }
  
  function hideQuestionThreeOne() {
    document.getElementById("quiz-question-three-one").style.display = "none";
  }
  
  function showQuestionFour() {
    document.getElementById("quiz-question-four").style.display = "block";
    showQuizStatus(7, 17);
  }
  
  function hideQuestionFour() {
    document.getElementById("quiz-question-four").style.display = "none";
  }
  
  function showQuestionFive() {
    document.getElementById("quiz-question-five").style.display = "block";
    showQuizStatus(8, 17);
  }
  
  function hideQuestionFive() {
    document.getElementById("quiz-question-five").style.display = "none";
  }
  
  function showQuestionSix() {
    document.getElementById("quiz-question-six").style.display = "block";
    showQuizStatus(9, 17);
  }
  
  function hideQuestionSix() {
    document.getElementById("quiz-question-six").style.display = "none";
  }
  
  function showQuestionSeven() {
    document.getElementById("quiz-question-seven").style.display = "block";
    showQuizStatus(10, 17);
  }
  
  function hideQuestionSeven() {
    document.getElementById("quiz-question-seven").style.display = "none";
  }
  
  function showQuizQuestionEightZero() {
    document.getElementById("quiz-question-eight-zero").style.display = "block";
    showQuizStatus(11, 17);
  }
  
  function hideQuizQuestionEightZero() {
    document.getElementById("quiz-question-eight-zero").style.display = "none";
  }
  
  function showQuestionEight() {
    document.getElementById("quiz-question-eight").style.display = "block";
    showQuizStatus(12, 17);
  }
  
  function hideQuestionEight() {
    document.getElementById("quiz-question-eight").style.display = "none";
  }
  
  function showQuestionNine() {
    document.getElementById("quiz-question-nine").style.display = "block";
    showQuizStatus(13, 17);
  }
  
  function hideQuestionNine() {
    document.getElementById("quiz-question-nine").style.display = "none";
  }
  
  function showQuestionTen() {
    document.getElementById("quiz-question-ten").style.display = "block";
    showQuizStatus(14, 17);
  }
  
  function hideQuestionTen() {
    document.getElementById("quiz-question-ten").style.display = "none";
  }
  
  function showQuestionFifteen() {
    document.getElementById("quiz-question-fifteen").style.display = "block";
    showQuizStatus(16, 17);
  }
  
  function hideQuestionFifteen() {
    document.getElementById("quiz-question-fifteen").style.display = "none";
  }
  
  function showQuestionSixteen() {
    document.getElementById("quiz-question-sixteen").style.display = "block";
    showQuizStatus(17, 17);
  }
  
  function hideQuestionSixteen() {
    document.getElementById("quiz-question-sixteen").style.display = "none";
  }

  function showQuestionEleven() {
    document.getElementById("quiz-question-eleven").style.display = "block";
    showQuizStatus(15, 17);
  }
  
  function hideQuestionEleven() {
    document.getElementById("quiz-question-eleven").style.display = "none";
  }
  
  function animateWidth(elementId, duration, delay) {
    setTimeout(function () {
      var start = null;
      var element = document.getElementById(elementId);
      var percentage = document.getElementById(elementId + "-percentage");
      var percentageFull = document.getElementById(
        elementId + "-percentage-full"
      );
  
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var percent = Math.floor(Math.min(progress / duration, 1) * 100);
  
        element.style.width = percent + "%";
  
        if (percent > 95) {
          percentageFull.innerHTML = percent + "%";
          percentage.innerHTML = "";
        } else {
          percentage.innerHTML = percent + "%";
          percentageFull.innerHTML = "";
        }
  
        if (progress < duration) {
          window.requestAnimationFrame(step);
        }
      }
  
      window.requestAnimationFrame(step);
    }, delay);
  }
  
  function showLoading() {
    document.getElementById("loading").style.display = "block";
    animateWidth("review-dental-loading", 4000, 0);
    animateWidth("assessing-quiz-loading", 4000, 4000);
    animateWidth("creating-solution-loading", 4000, 8000);
    setTimeout(function () {
      navigateForwardInHistory(null, "candidate");
    }, 12500);
  }
  
  function hideLoading() {
    document.getElementById("loading").style.display = "none";
  }
  
  function showCandidate() {
    document.getElementById("candidate").style.display = "block";
  }
  
  function hideCandidate() {
    document.getElementById("candidate").style.display = "none";
  }
  
  function showAll() {
    showQuestionLander();
    showNotEligible();
    showQuizStatus();
    showQuestionZeroOne();
    showQuestionZeroTwo();
    showQuestionOne();
    showQuestionTwo();
    showQuestionThree();
    showQuestionFour();
    showQuestionFive();
    showQuestionSix();
    showQuestionSeven();
    showQuestionEight();
    showQuestionNine();
    showQuestionTen();
    showLoading();
    showCandidate();
  }
  
  function hideAll() {
    hideQuestionLander();
    hideNotElegible();
    hideQuizStatus();
    hideQuestionZeroOne();
    hideQuestionZeroTwo();
    hideQuestionOne();
    hideQuestionTwo();
    hideQuestionThree();
    hideQuestionThreeOne();
    hideQuestionFour();
    hideQuestionFive();
    hideQuestionSix();
    hideQuestionSeven();
    hideQuestionEight();
    hideQuizQuestionEightZero();
    hideQuestionNine();
    hideQuestionTen();
    hideQuestionFifteen();
    hideQuestionSixteen();
    hideQuestionEleven();
    hideLoading();
    hideCandidate();
  }
  
  function navigateForwardInHistory(event, page) {
    if (event) {
      event.preventDefault();
    }
    hideAll();
    let stack = history.state.navigationStack;
    console.log(stack);
    stack.push(page);
    console.log("Navigate forward to ", page);
    history.pushState(
      {
        navigationStack: stack,
      },
      stack[stack.length - 1],
      "veneer-quiz"
    );
    showPage(stack[stack.length - 1]);
  }
  
  function navigateBackInHistory(event) {
    if (event) {
      event.preventDefault();
    }
    hideAll();
    console.log(history.state.navigationStack);
    let stack = history.state.navigationStack;
    stack.pop();
    if (stack.length > 0) {
      console.log("Navigate back to ", stack[stack.length - 1]);
      history.pushState(
        {
          navigationStack: stack,
        },
        stack[stack.length - 1],
        "veneer-quiz"
      );
      showPage(stack[stack.length - 1]);
    } else {
      history.replaceState(
        { navigationStack: ["home"] },
        "home",
        "veneer-quiz"
      );
      showQuestionLander();
    }
  }
  
  function showPage(page) {
    switch (page) {
      case "home":
        showQuestionLander();
        break;
      case "not-elegible":
        showNotEligible();
        break;
      case "quiz-question-zero-one":
        showQuestionZeroOne();
        break;
      case "quiz-quesiton-zero-two":
        showQuestionZeroTwo();
        break;
      case "quiz-question-one":
        showQuestionOne();
        break;
      case "quiz-question-two":
        showQuestionTwo();
        break;
      case "quiz-question-three":
        showQuestionThree();
        break;
      case "quiz-question-three-one":
        showQuestionThreeOne();
        break;
      case "quiz-question-four":
        showQuestionFour();
        break;
      case "quiz-question-five":
        showQuestionFive();
        break;
      case "quiz-question-six":
        showQuestionSix();
        break;
      case "quiz-question-seven":
        showQuestionSeven();
        break;
      case "quiz-question-eight":
        showQuestionEight();
        break;
      case "quiz-question-eight-zero":
        showQuizQuestionEightZero();
        break;
      case "quiz-question-nine":
        showQuestionNine();
        break;
      case "quiz-question-ten":
        showQuestionTen();
        break;
      case "quiz-question-fifteen":
        showQuestionFifteen();
        break;
      case "quiz-question-sixteen":
        showQuestionSixteen();
        break;
      case "quiz-question-eleven":
        showQuestionEleven();
        break;
      case "loading":
        showLoading();
        break;
      case "candidate":
        showCandidate();
        break;
    }
  }
  
  /********************** Listeners **********************/
  
  //window.onpopstate = navigateBackInHistory;
  
  document
    .getElementById("arrow-back")
    .addEventListener("click", navigateBackInHistory);
  document
    .getElementById("not-eligible-back")
    .addEventListener("click", navigateBackInHistory);
  
  document
    .getElementById("start-quiz")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-zero-one");
    });
  
  const questionTwoAnswers = document.getElementsByClassName(
    "quiz-question-zero-one-answers"
  );
  
  var goToQuestionZeroTwo = function () {
    navigateForwardInHistory(event, "quiz-quesiton-zero-two");
  };
  
  for (var i = 0; i < questionTwoAnswers.length; i++) {
    questionTwoAnswers[i].addEventListener("click", goToQuestionZeroTwo, false);
  }
  
  document
    .getElementById("quiz-question-zero-two-continue")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-one");
    });
  
  document
    .getElementById("quiz-question-one-yes")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "not-elegible");
    });
  
  document
    .getElementById("quiz-question-one-no")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-two");
    });
  
  document
    .getElementById("quiz-question-two-yes")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "not-elegible");
    });
  
  document
    .getElementById("quiz-question-two-no")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-three");
    });
  
  document
    .getElementById("quiz-question-three-both")
    .addEventListener("click", function (event) {
      setLocalStorageItem("teeth-to-cover", "both", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-three-one");
    });
  
  document
    .getElementById("quiz-question-three-top")
    .addEventListener("click", function (event) {
      setLocalStorageItem("teeth-to-cover", "top", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-three-one");
    });
  
  document
    .getElementById("quiz-question-three-bottom")
    .addEventListener("click", function (event) {
      setLocalStorageItem("teeth-to-cover", "bottom", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-three-one");
    });
  
  var questionThreeOneAnswers = document.getElementsByClassName(
    "quiz-question-three-one-answers"
  );
  
  var goToQuestionFour = function () {
    const option = getLocalStorageItem("teeth-to-cover");
    if (option == "both" || option == "top") {
      navigateForwardInHistory(event, "quiz-question-four");
    } else {
      navigateForwardInHistory(event, "quiz-question-six");
    }
  };
  
  for (var i = 0; i < questionThreeOneAnswers.length; i++) {
    questionThreeOneAnswers[i].addEventListener("click", goToQuestionFour, false);
  }
  
  document
    .getElementById("quiz-question-four-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("top-teeth-missing", "yes", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-five");
    });
  
  function navigateToQuizQuestionEight(event) {
    let topTeethMissing = getLocalStorageItem("top-teeth-missing");
    let bottomTeethMissing = getLocalStorageItem("bottom-teeth-missing");
  
    if (topTeethMissing == "yes" || bottomTeethMissing == "yes") {
      navigateForwardInHistory(event, "quiz-question-eight-zero");
    } else {
      navigateForwardInHistory(event, "quiz-question-eight");
    }
  }
  
  document
    .getElementById("quiz-question-eight-zero")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-eight");
    });
  
  document
    .getElementById("quiz-question-four-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("top-teeth-missing", "no", 30 * 24 * 60 * 60 * 1000);
      let teethToCover = getLocalStorageItem("teeth-to-cover");
      if (teethToCover == "both" || teethToCover == "bottom") {
        navigateForwardInHistory(event, "quiz-question-six");
      } else {
        navigateToQuizQuestionEight(event);
      }
    });
  
  document
    .getElementById("quiz-question-five-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("one-purple-or-orange-top", "yes", 30 * 24 * 60 * 60 * 1000);
  
      let teethToCover = getLocalStorageItem("teeth-to-cover");
      if (teethToCover == "both" || teethToCover == "bottom") {
        navigateForwardInHistory(event, "quiz-question-six");
      } else {
        navigateToQuizQuestionEight(event);
      }
    });
  
  document
    .getElementById("quiz-question-five-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("one-purple-or-orange-top", "no", 30 * 24 * 60 * 60 * 1000);
  
      let teethToCover = getLocalStorageItem("teeth-to-cover");
      if (teethToCover == "both" || teethToCover == "bottom") {
        navigateForwardInHistory(event, "quiz-question-six");
      } else {
        navigateToQuizQuestionEight(event);
      }
    });
  
  document
    .getElementById("quiz-question-six-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("bottom-teeth-missing", "yes", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-seven");
    });
  
  document
    .getElementById("quiz-question-six-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("bottom-teeth-missing", "no", 30 * 24 * 60 * 60 * 1000);
      navigateToQuizQuestionEight(event);
    });
  
  document
    .getElementById("quiz-question-seven-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("one-purple-or-orange-bottom", "yes", 30 * 24 * 60 * 60 * 1000);
      navigateToQuizQuestionEight(event);
    });
  
  document
    .getElementById("quiz-question-seven-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("one-purple-or-orange-bottom", "no", 30 * 24 * 60 * 60 * 1000);
      navigateToQuizQuestionEight(event);
    });
  
  document
    .getElementById("shade-bl1")
    .addEventListener("click", function (event) {
      setLocalStorageItem("shade-type", "shade-bl1", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-nine");
    });
  document.getElementById("shade-a1").addEventListener("click", function (event) {
    setLocalStorageItem("shade-type", "shade-a1", 30 * 24 * 60 * 60 * 1000);
    navigateForwardInHistory(event, "quiz-question-nine");
  });
  document.getElementById("shade-a2").addEventListener("click", function (event) {
    setLocalStorageItem("shade-type", "shade-a2", 30 * 24 * 60 * 60 * 1000);
    navigateForwardInHistory(event, "quiz-question-nine");
  });
  document.getElementById("shade-a3").addEventListener("click", function (event) {
    setLocalStorageItem("shade-type", "shade-a3", 30 * 24 * 60 * 60 * 1000);
    navigateForwardInHistory(event, "quiz-question-nine");
  });
  
  document
    .getElementById("issue-none")
    .addEventListener("click", function (event) {
      event.preventDefault();
      setLocalStorageItem("additional-issue", "", 30 * 24 * 60 * 60 * 1000);
      var radioButtons = document.querySelectorAll(
        'input[type="checkbox"][name="issues"]'
      );
  
      radioButtons.forEach(function (radioButton) {
        radioButton.checked = false;
      });
      var container = document.getElementById("issue-none");
      var radioButton = container.querySelector('input[type="radio"]');
      if (radioButton) {
        radioButton.checked = !radioButton.checked;
      }
      navigateForwardInHistory(event, "quiz-question-ten");
    });
  
  document
    .getElementById("issue-gapped")
    .addEventListener("click", function (event) {
      event.preventDefault();
      var container = document.getElementById("issue-gapped");
      var radioButton = container.querySelector('input[type="checkbox"]');
      if (radioButton) {
        radioButton.checked = !radioButton.checked;
      }
      var container = document.getElementById("issue-none");
      var none = container.querySelector('input[type="radio"]');
      if (none) {
        none.checked = false;
      }
      let additionalIssues = getLocalStorageItem("additional-issue");
      if (additionalIssues == null) {
        additionalIssues = [];
      } else {
        additionalIssues = additionalIssues.split(",");
      }
      let indexOfIssue = additionalIssues.indexOf("gapped");
      console.log("Index of issue", indexOfIssue);
      if (indexOfIssue >= 0) {
        additionalIssues.splice(indexOfIssue, 1);
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      } else {
        additionalIssues.push("gapped");
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      }
    });
  
  document
    .getElementById("issue-discolored")
    .addEventListener("click", function (event) {
      event.preventDefault();
      var container = document.getElementById("issue-discolored");
      var radioButton = container.querySelector('input[type="checkbox"]');
      if (radioButton) {
        radioButton.checked = !radioButton.checked;
      }
      var container = document.getElementById("issue-none");
      var none = container.querySelector('input[type="radio"]');
      if (none) {
        none.checked = false;
      }
      let additionalIssues = getLocalStorageItem("additional-issue");
      if (additionalIssues == null) {
        additionalIssues = [];
      } else {
        additionalIssues = additionalIssues.split(",");
      }
      let indexOfIssue = additionalIssues.indexOf("discolored");
      if (indexOfIssue >= 0) {
        additionalIssues.splice(indexOfIssue, 1);
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      } else {
        additionalIssues.push("discolored");
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      }
    });
  
  document
    .getElementById("issue-crowded")
    .addEventListener("click", function (event) {
      event.preventDefault();
      var container = document.getElementById("issue-crowded");
      var radioButton = container.querySelector('input[type="checkbox"]');
      if (radioButton) {
        radioButton.checked = !radioButton.checked;
      }
      var container = document.getElementById("issue-none");
      var none = container.querySelector('input[type="radio"]');
      if (none) {
        none.checked = false;
      }
      let additionalIssues = getLocalStorageItem("additional-issue");
      if (additionalIssues == null) {
        additionalIssues = [];
      } else {
        additionalIssues = additionalIssues.split(",");
      }
      let indexOfIssue = additionalIssues.indexOf("crowded");
      if (indexOfIssue >= 0) {
        additionalIssues.splice(indexOfIssue, 1);
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      } else {
        additionalIssues.push("crowded");
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      }
    });
  
  document
    .getElementById("issue-chipped")
    .addEventListener("click", function (event) {
      event.preventDefault();
      var container = document.getElementById("issue-chipped");
      var radioButton = container.querySelector('input[type="checkbox"]');
      if (radioButton) {
        radioButton.checked = !radioButton.checked;
      }
      var container = document.getElementById("issue-none");
      var none = container.querySelector('input[type="radio"]');
      if (none) {
        none.checked = false;
      }
      let additionalIssues = getLocalStorageItem("additional-issue");
      if (additionalIssues == null) {
        additionalIssues = [];
      } else {
        additionalIssues = additionalIssues.split(",");
      }
      let indexOfIssue = additionalIssues.indexOf("chipped");
      if (indexOfIssue >= 0) {
        additionalIssues.splice(indexOfIssue, 1);
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      } else {
        additionalIssues.push("chipped");
        setLocalStorageItem(
          "additional-issue",
          additionalIssues.join(","),
          30 * 24 * 60 * 60 * 1000
        );
      }
    });
  
  document
    .getElementById("issue-next")
    .addEventListener("click", function (event) {
      event.preventDefault();
      let additionalIssues = getLocalStorageItem("additional-issue");
      if (additionalIssues == null) {
        additionalIssues = [];
      }
      navigateForwardInHistory(event, "quiz-question-ten");
    });
  
  document
    .getElementById("quiz-question-ten-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("strong-to-eat", "yes", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-eleven");
    });
  
  document
    .getElementById("quiz-question-ten-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("strong-to-eat", "no", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-eleven");
    });

  document
    .getElementById("quiz-question-eleven-yes")
    .addEventListener("click", function (event) {
      setLocalStorageItem("rush", "yes", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-fifteen");
    });
  
  document
    .getElementById("quiz-question-eleven-no")
    .addEventListener("click", function (event) {
      setLocalStorageItem("rush", "no", 30 * 24 * 60 * 60 * 1000);
      navigateForwardInHistory(event, "quiz-question-fifteen");
    });
  
  document
    .getElementById("quiz-question-fifteen-yes")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-sixteen");
    });
  
  document
    .getElementById("quiz-question-fifteen-no")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "quiz-question-sixteen");
    });
  
  document
    .getElementById("quiz-question-sixteen-continue")
    .addEventListener("click", function (event) {
      navigateForwardInHistory(event, "loading");
    });
  
  document
    .getElementById("fullname")
    .addEventListener("change", function (event) {
      setLocalStorageItem("fullname", this.value, 30 * 24 * 60 * 60 * 1000);
    });
  
  document.getElementById("email").addEventListener("change", function (event) {
    setLocalStorageItem("email", this.value, 30 * 24 * 60 * 60 * 1000);
  });
  
  document
    .getElementById("see-veneers")
    .addEventListener("click", function (event) {
      event.preventDefault();
      const fullname = document.getElementById("fullname").value;
      const email = document.getElementById("email").value;
  
      _learnq.push([
        "identify",
        {
          $email: email,
          $first_name: fullname.split(" ")[0],
          $last_name: fullname.split(" ")[1] || "",
        },
      ]);
  
      _learnq.push([
        "track",
        "Signed Up",
        {
          Source: "Website",
        },
      ]);
  
      window.location.href = "your-veneer-results";
    });
  document
    .getElementById("skip-info-step")
    .addEventListener("click", function (event) {
      event.preventDefault();
      window.location.href = "your-veneer-results";
    });
  
  try {
    history.replaceState({ navigationStack: ["home"] }, "home", "veneer-quiz");
  } catch (e) {
    console.log("Error from debug");
  }
  